import * as React from 'react';
import { Component } from 'react';
import { Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';
import * as moment from 'moment';

import './job-detail.scss';

interface JobDetailComponentProps {
  job: any;
  isOpen: boolean;
  onClosed?: () => void;
}

interface JobDetailComponentState {
  isOpen: boolean;
}

class JobDetail extends Component<JobDetailComponentProps, JobDetailComponentState> {

  static getDerivedStateFromProps(nextProps: JobDetailComponentProps): JobDetailComponentState {
    return {
      isOpen: nextProps.isOpen
    };
  }

  constructor(props: any) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.renderProject = this.renderProject.bind(this);
    this.renderTech = this.renderTech.bind(this);

    this.state = {isOpen: false};
  }

  toggle() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    const job = this.props.job || {projects: []};

    return (
        <Modal isOpen={this.state.isOpen}
               toggle={this.toggle}
               centered={true}
               backdrop={true}
               onExit={this.props.onClosed}
               size="lg"
               role="job-detail"
        >
          <ModalHeader toggle={this.toggle} tag="div">
            <h3>{job.position}</h3>
            <h4>
              <span>{job.company}</span>
              <span>{this.formatDate(job.startDate)} - {this.formatDate(job.endDate, 'Present')}</span>
            </h4>
          </ModalHeader>
          <ModalBody>
            {job.projects.map(this.renderProject)}
          </ModalBody>
        </Modal>
    );
  }

  renderProject(project: any, index: number) {
    return (
        <article role="project" key={`pro-${index}`}>
          <h6>
            {project.name}
            {project.customer && <span> - {project.customer}</span>}
          </h6>
          <p dangerouslySetInnerHTML={{__html: project.description}}/>
          <ul className="list-inline" role="stack">
            {project.stack.map(this.renderTech)}
          </ul>
        </article>
    );
  }

  renderTech(tech: string, index: number) {
    return (
        <li key={`tech-${index}`} className="list-inline-item">
          <Badge pill={true}>{tech}</Badge>
        </li>
    );
  }

  private formatDate(date: moment.Moment | null | undefined, or: string = '') {
    return date ? date.format('MMM. YYYY') : or;
  }
}

export default JobDetail;



// WEBPACK FOOTER //
// ./src/components/jobs/job-detail/job-detail.component.tsx